import { render, staticRenderFns } from "./unicomDeal5.vue?vue&type=template&id=98ab2ac4&scoped=true"
import script from "./unicomDeal5.vue?vue&type=script&lang=js"
export * from "./unicomDeal5.vue?vue&type=script&lang=js"
import style0 from "./unicomDeal5.vue?vue&type=style&index=0&id=98ab2ac4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98ab2ac4",
  null
  
)

export default component.exports